// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"998":"css/app.7033","7933":"css/admin-app.7033"}[chunkId] + ".css";
};